export interface ICountries {
    country: string;
    country_code: string;
}
